import { useTheme } from '@emotion/react';
import cn from 'classnames';

import { IConDefaultType } from '../types';

export enum EmotionIconVariant {
  SMILE = 'smile',
  FILL = 'fill',
}

interface IEmotionIconProps extends IConDefaultType {
  variant?: EmotionIconVariant;
}

function EmotionIcon({
  className,
  size = 24,
  rotate,
  flip,
  color,
  variant = EmotionIconVariant.SMILE,
}: IEmotionIconProps) {
  const theme = useTheme();
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === EmotionIconVariant.SMILE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            transform="translate(3 3)"
            d="M9.00004 0C11.4853 0 13.5 2.01472 13.5 4.5C13.5 6.13588 12.6267 7.56713 11.3212 8.35488C13.0623 8.75416 14.4607 9.59778 15.5215 10.7007C17.0013 12.2392 17.7855 14.2344 17.9895 16.1051C18.1085 17.1969 17.2045 18 16.2352 18H1.76488C0.795544 18 -0.10845 17.1969 0.0105844 16.1051C0.214547 14.2344 0.998763 12.2392 2.47855 10.7007C3.53919 9.59795 4.9373 8.75424 6.67797 8.35488C5.37288 7.56705 4.50004 6.13562 4.50004 4.5C4.50004 2.01472 6.51476 0 9.00004 0Z"
            fill={color || theme.color.icon.icon_3}
          />
        </svg>
      )}
      {variant === EmotionIconVariant.FILL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            transform="translate(3 3)"
            d="M9 0C13.9705 0 18 4.02944 18 9C18 13.9705 13.9705 18 9 18C4.02944 18 0 13.9705 0 9C0 4.02944 4.02944 0 9 0ZM6.54545 5.72727C6.09369 5.72727 5.72727 6.09365 5.72727 6.54545C5.72727 6.99725 6.09369 7.36364 6.54545 7.36364C7.0052 7.36364 7.37165 6.99725 7.37165 6.54545C7.37165 6.09366 7.0052 5.72727 6.54545 5.72727ZM11.4545 5.72727C11.0027 5.72727 10.6364 6.09365 10.6364 6.54545C10.6364 6.99725 11.0027 7.36364 11.4545 7.36364C11.9143 7.36364 12.2807 6.99725 12.2807 6.54545C12.2807 6.09366 11.9143 5.72727 11.4545 5.72727ZM5.72727 10.2273C6.38182 11.4545 7.52727 12.2727 9 12.2727C10.4727 12.2727 11.6182 11.4545 12.2727 10.2273"
            fill={color || theme.color.icon.icon_3}
          />
        </svg>
      )}
      {variant === EmotionIconVariant.FILL && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            transform="translate(3 3)"
            d="M9 0C13.9705 0 18 4.02944 18 9C18 13.9705 13.9705 18 9 18C4.02944 18 0 13.9705 0 9C0 4.02944 4.02944 0 9 0ZM6.54545 5.72727C6.09369 5.72727 5.72727 6.09365 5.72727 6.54545C5.72727 6.99725 6.09369 7.36364 6.54545 7.36364C7.0052 7.36364 7.37165 6.99725 7.37165 6.54545C7.37165 6.09366 7.0052 5.72727 6.54545 5.72727ZM11.4545 5.72727C11.0027 5.72727 10.6364 6.09365 10.6364 6.54545C10.6364 6.99725 11.0027 7.36364 11.4545 7.36364C11.9143 7.36364 12.2807 6.99725 12.2807 6.54545C12.2807 6.09366 11.9143 5.72727 11.4545 5.72727ZM5.72727 10.2273C6.38182 11.4545 7.52727 12.2727 9 12.2727C10.4727 12.2727 11.6182 11.4545 12.2727 10.2273"
            fill={color || theme.color.icon.icon_3}
          />
        </svg>
      )}
    </i>
  );
}

export default EmotionIcon;
